import React from "react";
import { useNotaire } from "../context/NotaireContext";
//catalyst tailwind
import { Heading } from '../components/catalyst/heading'
import AllAffaires from "../components/AllAffaires";
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/24/solid';


function Affaires(args) {
  const context = useNotaire();
  //console.log("all affaire",args);
  //console.log("context",context);
  //check montant abonnement notaire
  // check montant abonnement notaire (tolérant aux valeurs manquantes)
  const rawAbonnement = context?.infoEtude?.stripe_abonnement ?? 0;
  const montantAbonnement =
    typeof rawAbonnement === 'number'
      ? rawAbonnement
      : (parseFloat(String(rawAbonnement).replace(',', '.').replace(/[^\d.]/g, '')) || 0);


  //console.log("abonnement2",abonnement);

  //console.log("affaire args",args);

  if (args.user !== null) {
    return (

      <div className="container">
        <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
          <Heading>Vos affaires</Heading>

          <div className="flex gap-4">
           {/** <Link to="/app/nouvelle-affaire"><button class="btn-primary inline-flex" ><PlusIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" /> Nouvelle affaire</button></Link> **/}
          </div>

        </div>
        <div className="mt-10">
          {args.immo !== null &&
            <AllAffaires />
          }
          {args === null &&
            <div className="text-center">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="mx-auto size-12 text-gray-400"
              >
                <path
                  d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                  strokeWidth={2}
                  vectorEffect="non-scaling-stroke"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <h3 className="mt-2 text-sm font-semibold text-gray-900">Aucune affaire</h3>
              <p className="mt-1 text-sm text-gray-500">Vous recevrez un email lorsqu'une affaire vous sera confié.</p>
              <div className="mt-6">
                <Link
                  to="/app/nouvelle-affaire"
                  type="button"
                  className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5" />
                  Nouvelle affaire
                </Link>
              </div>
            </div>
          }
        </div>
      </div>

    )
  }
}

export default Affaires;